import type {Moment} from 'moment-timezone'
import moment from 'moment-timezone'
import type {DehydratedMathAssessmentTopicT} from '@freckle/educator-entities/ts/math/assessment/types/assessment-topic'
import {fancyClient, extractData} from '@freckle/educator-entities/ts/openapi-clients'

export type MathSchoolAssessmentAssignmentT = {
  id: number
  createdAt: Moment
  topic: DehydratedMathAssessmentTopicT | undefined | null
  benchmarkId: number | undefined | null
  teacherIds: Array<number>
}
export async function fetchMathSchoolAssessmentAssignment(
  schoolId: number,
  year: number
): Promise<Array<MathSchoolAssessmentAssignmentT>> {
  const dateInYear = moment({year, month: 0, day: 1})
  return fancyClient
    .GET('/2/schools/{SchoolP-SchoolId}/assessments2', {
      params: {
        path: {'SchoolP-SchoolId': schoolId},
        query: {
          from: dateInYear.startOf('year').utc().valueOf(),
          to: dateInYear.endOf('year').utc().valueOf()
        }
      }
    })
    .then(extractData)
    .then(data =>
      data.map(a => ({
        ...a,
        createdAt: moment(a.createdAt),
        topic: a.topic as DehydratedMathAssessmentTopicT | undefined | null,
        benchmarkId: a.benchmarkId
      }))
    )
}
